import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-loader-container"},[(_vm.loading)?_c(VProgressCircular,{attrs:{"size":_vm.size,"color":_vm.color,"indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }